/**
 * Lokale Fallback-Icons für Mollie-Zahlungsmethoden.
 *
 * Verwendet als `onError`-Fallback im `PaymentMethodBadge`, wenn die offizielle
 * Mollie-CDN-URL nicht erreichbar ist (Offline-Render, CSP-Block, E-Mail/PDF).
 * Die SVGs sind bewusst schlank (~200-400 Bytes) und zeigen das Method-Kürzel
 * in der Brand-Farbe — sie ersetzen die großen offiziellen Logos absichtlich
 * nicht.
 *
 * Der `file-loader` in `webpack.config.js` liefert die Imports als URL-String
 * zurück (siehe `src/shared/@types/declarations.d.ts`).
 */
import creditcard from "./creditcard.svg";
import paypal from "./paypal.svg";
import directdebit from "./directdebit.svg";
import banktransfer from "./banktransfer.svg";
import applepay from "./applepay.svg";
import googlepay from "./googlepay.svg";
import wero from "./wero.svg";

export const MOLLIE_FALLBACK_ICONS: {[method: string]: string} = {
    creditcard,
    paypal,
    directdebit,
    banktransfer,
    applepay,
    googlepay,
    wero,
};
